module.exports = __webpack_public_path__ + "static/media/navbar-ico-4.06fb4607.svg";